import PropTypes from 'prop-types'
import React from 'react'
import "./Bus.scss"

function Bus({ elements = [], choices = []}) {
    const [state, setState] = React.useState({
        doShadow: true,
        doPanels: false,
        doPropultion: false,
        doAntenna: false,
        doElectrical: false,

        propultionChoice: '',
        attitudeChoice: '',
    })


    React.useEffect( () => {
        if (!elements) {
            return;
        }
        const doPanels = true;//elements.find(e  => e.id === 'panels-id')
        const doPropultion = elements.find(e => e.busPart === 'propulsion')
        const doAntenna = elements.find(e => e.busPart === 'attitude')
        const doElectrical = elements.find(e => e.busPart === 'electrical')
        const doShadow = doAntenna === true && doPanels === true

        const propulsion  = choices.find(c => {
                if (c.category.busPart === "propulsion") {
                    return c
                }
        })
        let  propulsionChoice = 'N/A'
        if (propulsion) {
            propulsionChoice = propulsion.choice?.deploy?.value + ' '+propulsion.choice.deploy?.unit
        }

        const attitude  = choices.find(c => {
            if (c.category.busPart === "attitude") {
                return c
            }
        })
        let  attitudeChoice = 'N/A'
        if (attitude) {
            attitudeChoice = doAntenna.name +' '+ attitude?.choice.name;
        }

        setState({
            doShadow: typeof doAntenna !== "undefined",
            doPanels: typeof doPanels !== "undefined",
            doPropultion:typeof doPropultion !== "undefined" ,
            doAntenna: typeof doAntenna !== "undefined",
            doElectrical: typeof doElectrical !== "undefined" || typeof doAntenna !== "undefined",
            propulsionChoice,
            attitudeChoice,
        })
    }, [elements, choices])
    if (elements.length < 0 ){
        return null
    }

    return <>

        <div className="bus-container" >


        <svg xmlns="http://www.w3.org/2000/svg" width="255" height="258" viewBox="0 0 155 158">
            <g id="Group_966" data-name="Group 966" transform="translate(-10159 -919)">
                <g id="Polygon_5" data-name="Polygon 5" transform="translate(10162 975) rotate(-90)" fill="none" strokeLinecap="round" strokeLinejoin="round">
                <path d="M26.5,0,53,37H0Z" stroke="none"/>
                <path d="M 26.5 0 L 0 37 L 53 37 L 26.5 0 M 26.5 -3 C 27.46750068664551 -3 28.37561988830566 -2.533401489257812 28.9389705657959 -1.746829986572266 L 55.43896865844727 35.25317001342773 C 56.09371185302734 36.16733932495117 56.18227005004883 37.37089157104492 55.66838073730469 38.37104034423828 C 55.15449142456055 39.37120056152344 54.12445068359375 40 53 40 L 0 40 C -1.12445068359375 40 -2.154491424560547 39.37120056152344 -2.668380737304688 38.37104034423828 C -3.182270050048828 37.37089157104492 -3.093711853027344 36.16733932495117 -2.438968658447266 35.25317001342773 L 24.0610294342041 -1.746829986572266 C 24.62438011169434 -2.533401489257812 25.53249931335449 -3 26.5 -3 Z" stroke="none" fill="#78a1bb"/>
                </g>
                <g id="Polygon_9" data-name="Polygon 9" transform="translate(10311 1021) rotate(90)" fill="none" strokeLinecap="round" strokeLinejoin="round">
                <path d="M26.5,0,53,38H0Z" stroke="none"/>
                <path d="M 26.5 0 L 0 38 L 53 38 L 26.5 0 M 26.5 -3 C 27.48081970214844 -3 28.39969062805176 -2.520549774169922 28.96072959899902 -1.716041564941406 L 55.46073150634766 36.28395843505859 C 56.10005950927734 37.20072937011719 56.17673873901367 38.39688873291016 55.65970993041992 39.38777923583984 C 55.14268112182617 40.37868118286133 54.11766815185547 41 53 41 L 0 41 C -1.117668151855469 41 -2.142681121826172 40.37868118286133 -2.659709930419922 39.38777923583984 C -3.176738739013672 38.39688873291016 -3.100059509277344 37.20072937011719 -2.460731506347656 36.28395843505859 L 24.03927040100098 -1.716041564941406 C 24.60030937194824 -2.520549774169922 25.51918029785156 -3 26.5 -3 Z" stroke="none" fill="#78a1bb"/>
                </g>
                <g id="Polygon_8" data-name="Polygon 8" transform="translate(10162 1074) rotate(-90)" fill="none" strokeLinecap="round" strokeLinejoin="round">
                <path d="M26.5,0,53,37H0Z" stroke="none"/>
                <path d="M 26.5 0 L 0 37 L 53 37 L 26.5 0 M 26.5 -3 C 27.46750068664551 -3 28.37561988830566 -2.533401489257812 28.9389705657959 -1.746829986572266 L 55.43896865844727 35.25317001342773 C 56.09371185302734 36.16733932495117 56.18227005004883 37.37089157104492 55.66838073730469 38.37104034423828 C 55.15449142456055 39.37120056152344 54.12445068359375 40 53 40 L 0 40 C -1.12445068359375 40 -2.154491424560547 39.37120056152344 -2.668380737304688 38.37104034423828 C -3.182270050048828 37.37089157104492 -3.093711853027344 36.16733932495117 -2.438968658447266 35.25317001342773 L 24.0610294342041 -1.746829986572266 C 24.62438011169434 -2.533401489257812 25.53249931335449 -3 26.5 -3 Z" stroke="none" fill="#78a1bb"/>
                </g>
                <g id="Polygon_10" data-name="Polygon 10" transform="translate(10311 922) rotate(90)" fill="none" strokeLinecap="round" strokeLinejoin="round">
                <path d="M26.5,0,53,38H0Z" stroke="none"/>
                <path d="M 26.5 0 L 0 38 L 53 38 L 26.5 0 M 26.5 -3 C 27.48081970214844 -3 28.39969062805176 -2.520549774169922 28.96072959899902 -1.716041564941406 L 55.46073150634766 36.28395843505859 C 56.10005950927734 37.20072937011719 56.17673873901367 38.39688873291016 55.65970993041992 39.38777923583984 C 55.14268112182617 40.37868118286133 54.11766815185547 41 53 41 L 0 41 C -1.117668151855469 41 -2.142681121826172 40.37868118286133 -2.659709930419922 39.38777923583984 C -3.176738739013672 38.39688873291016 -3.100059509277344 37.20072937011719 -2.460731506347656 36.28395843505859 L 24.03927040100098 -1.716041564941406 C 24.60030937194824 -2.520549774169922 25.51918029785156 -3 26.5 -3 Z" stroke="none" fill="#78a1bb"/>
                </g>
                <line id="Line_206" data-name="Line 206" y2="98.5" transform="translate(10160.5 948.5)" fill="none" stroke="#78a1bb" strokeLinecap="round" strokeWidth="3"/>
                <line id="Line_219" data-name="Line 219" y2="98.5" transform="translate(10312.5 948.5)" fill="none" stroke="#78a1bb" strokeLinecap="round" strokeWidth="3"/>
                <line id="Line_209" data-name="Line 209" y1="47.324" transform="translate(10271.5 974.088)" fill="none" stroke="#78a1bb" strokeWidth="3"/>
                <line id="Line_214" data-name="Line 214" y1="47.324" transform="translate(10200.5 974.176)" fill="none" stroke="#78a1bb" strokeWidth="3"/>
                <line id="Line_215" data-name="Line 215" x2="74" transform="translate(10199.5 1019.5)" fill="none" stroke="#78a1bb" strokeWidth="3"/>
                <line id="Line_217" data-name="Line 217" x2="74" transform="translate(10199.5 976.5)" fill="none" stroke="#78a1bb" strokeWidth="3"/>
                <line id="Line_218" data-name="Line 218" x2="74" transform="translate(10199.5 920.5)" fill="none" stroke="#78a1bb" strokeWidth="3"/>
                <path id="Path_353" data-name="Path 353" d="M0,0H74" transform="translate(10199.5 1075.5)" fill="none" stroke="#78a1bb" strokeWidth="3"/>
            </g>
            </svg>
        </div>
   </>
    // return <img src={'https://upload.wikimedia.org/wikipedia/commons/c/c0/SpacecraftBus-model.jpg'}  alt={''}/>
}

export default Bus;

Bus.propTypes = {
  elements: PropTypes.array
}

Bus.defaultProps = {
  elements: []
}
